var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPrint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8 0.25C14.1797 0.25 14.4935 0.532154 14.5432 0.898229L14.55 1V5.85H15.4C16.6438 5.85 17.6619 6.81628 17.7446 8.0391L17.75 8.2V12.2C17.75 13.4438 16.7837 14.4619 15.5609 14.5446L15.4 14.55H13.8C13.7832 14.55 13.7665 14.5494 13.75 14.5484V15.8C13.75 16.2142 13.4142 16.55 13 16.55H5C4.58579 16.55 4.25 16.2142 4.25 15.8V14.5466L4.2 14.55H2.6C1.35621 14.55 0.338104 13.5837 0.255422 12.3609L0.25 12.2V8.2C0.25 6.95621 1.21628 5.9381 2.4391 5.85542L2.6 5.85H3.45V1C3.45 0.620304 3.73215 0.306509 4.09823 0.256847L4.2 0.25H13.8ZM4.25 13.0516V11.8C4.25 11.3858 4.58579 11.05 5 11.05H13C13.4142 11.05 13.75 11.3858 13.75 11.8V13.0534L13.8 13.05H15.4C15.8333 13.05 16.1909 12.7257 16.2434 12.3066L16.25 12.2V8.2C16.25 7.76667 15.9257 7.40907 15.5066 7.35662L15.4 7.35H13.8H4.2H2.6C2.16667 7.35 1.80907 7.67426 1.75662 8.09338L1.75 8.2V12.2C1.75 12.6333 2.07426 12.9909 2.49338 13.0434L2.6 13.05H4.2C4.2168 13.05 4.23347 13.0506 4.25 13.0516ZM13.05 1.75V5.85H4.95V1.75H13.05ZM12.25 12.55V15.05H5.75V12.55H12.25Z",
    fill: "#3F3E3E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrint);
export default __webpack_public_path__ + "static/media/icon-print.acd5348bc5c5fd299cd0faa0d918386d.svg";
export { ForwardRef as ReactComponent };